
define('text!templates/tabbutton.html',[],function () { return '<input type="radio" id="{{id}}" name="{{name}}" {{#hasDataBind}}data-bind="{{dataBind}}"{{/hasDataBind}} value="{{value}}" {{#isChecked}}checked="checked"{{/isChecked}}{{#isDisabled}} disabled="true"{{/isDisabled}}/><label for="{{id}}">{{label}}</label>';});

